// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightLanding-cls1_tkX","cls2":"CiterightLanding-cls2_-4t CiterightLanding-cls1_tkX"};